import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
/**
 * This is used primarily to help the secondary nav bar on the student page "talk" to the tabs.  Tell them to reload,
 * etc.
 * For example, if I want stuff that relies on notes to reload if the user is on it, I would call setReloadNotes(true).  The notes
 * tab listens for this change, sets reloadNotes to false, and then attempts to reload the notes.
 *
 * These reload properties should be made according to the type of domain they'll affect, not individual tabs.  For example,
 * the activity tab shows a lot of different kinds of things.  The tab should have the decision of when to reload based
 * on what's changed.  The activity feed can decide to reload according to changes in notes, or alerts, or ignore it.
 */
export const AdvisorStudentsContentContext = React.createContext({
    currentUserFollowedAction: null,
    setCurrentUserFollowedAction: () => { },
    opportunityInfo: null,
});
const AdvisorStudentContentContextProvider = ({ opportunityInfo, children, }) => {
    const [currentUserFollowedAction, setCurrentUserFollowedAction] = React.useState(null);
    return (_jsx(AdvisorStudentsContentContext.Provider, { value: {
            currentUserFollowedAction,
            setCurrentUserFollowedAction,
            opportunityInfo,
        }, children: children }));
};
export const useAdvisorStudentsContentContext = () => React.useContext(AdvisorStudentsContentContext);
export default AdvisorStudentContentContextProvider;
